import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import Header from '../Header';
import Sidebar from '../Sidebar';
import Footer from '../Footer';

const MainLayout = ({
  history,
  refresh,
  ContentBody,
}) => {
  const { isClickedMenuButton, isHoverMenu } = useSelector(state => state.sidebar);

  return (
    <Fragment>
      <Header history={history}/>
      <div className='content-wrap'>
        <Sidebar history={history} refresh={refresh}/>
        <div className={`content ${isClickedMenuButton? '' : isHoverMenu ? 'view':'close'}`}>
          {ContentBody}
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default MainLayout;